import React from "react";
import "../src/assets/scss/main.scss";
import { Routes, Route } from "react-router-dom";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import SideBar from "./components/common/SideBar";
import OurBlog from "./pages/OurBlog";
import Authors from "./pages/Authors";
import BlogDetails from "./pages/BlogDetails";
import ConnectWallet from "./pages/ConnectWallet";
import Contact from "./pages/Contact";
import EditProfile from "./pages/EditProfile";
import Error from "./pages/Error";
import Explore from "./pages/Explore";
import Faq from "./pages/Faq";
import Home from "./pages/Home";
import HotCollection from "./pages/HotCollection";
import Popular from "./pages/Popular";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Product from "./pages/Product";
import Profile from "./pages/Profile";
import Ranking from "./pages/Ranking";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import UploadWork from "./pages/UploadWork";
import useAuth from "./Hooks/useAuth";
import Loader from "./components/common/Loader";

function App() {
  const {loader,stickyNav} = useAuth()
  return (
    <div className="App">
        {
          loader && <Loader/>
        }
        <SideBar />
        <Header />
        <div className={stickyNav ? 'scroll-padding' : ''}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ourblog" element={<OurBlog />} />
            <Route path="/blogdetails/:id" element={<BlogDetails />} />
            <Route path="/authors" element={<Authors />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/hot-collection" element={<HotCollection />} />
            <Route path="/connectwallet" element={<ConnectWallet />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="faq" element={<Faq />} />
            <Route path="/popular" element={<Popular />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/edit-profile/:id" element={<EditProfile />} />
            <Route path="/ranking" element={<Ranking />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/uploadwork" element={<UploadWork />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </div>
        <Footer/>
    </div>
  );
}

export default App;
